"use strict";

exports.__esModule = true;
exports.text = exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _emotion = require("emotion");
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _utils = require("../../shared/utils");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var text = function text(props) {
  return /*#__PURE__*/(
    (0, _emotion.css)("margin:", props.margin || 0, ";padding:", props.padding || '0', ";color:", (0, _utils.getTextColor)(props), ";")
  );
};
exports.text = text;
var H1 = /*#__PURE__*/
(0, _reactEmotion.default)('h1', {
  target: "e3vsrj70"
})(_base.default, ";", _font.default, ";", text, ";font-size:", function (props) {
  return props.fontSize || '3.25rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '4rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 300;
}, ";text-align:", function (props) {
  return props.center ? 'center' : 'inherit';
}, ";", (0, _mediaQueries.default)('md'), "{font-size:1.625rem;line-height:2.25rem;}");
var _default = H1;
exports.default = _default;